module.exports = __webpack_public_path__ + "img/1438075528.96ba1fd3.jpg";